export default __webpack_public_path__ + "static/card-5-8b82da0ba21f10407ab6eb38d89df223.png";